function firstChildByLocalName(parent, localName) {
  return Array.from(parent?.getElementsByTagName('*') || []).find((node) => node.localName === localName) || null;
}

function childText(parent, localName) {
  return firstChildByLocalName(parent, localName)?.textContent?.trim() || '';
}

function plainText(value) {
  const container = document.createElement('div');
  container.innerHTML = value || '';
  return (container.textContent || '').replace(/\s+/g, ' ').trim();
}

function normalizeType(value) {
  const text = String(value || '').toLowerCase();
  if (text.includes('multi')) return 'multi';
  if (text.includes('mystery') || text.includes('unknown') || text.includes('puzzle')) return 'mystery';
  if (text.includes('earth')) return 'earthcache';
  if (text.includes('virtual')) return 'virtual';
  if (text.includes('event')) return 'event';
  if (text.includes('letterbox')) return 'letterbox';
  return 'traditional';
}

export function parseGpx(text) {
  const xml = new DOMParser().parseFromString(text, 'application/xml');
  const parseError = xml.querySelector('parsererror');
  if (parseError) throw new Error('This file is not valid GPX XML.');
  const waypoints = Array.from(xml.getElementsByTagName('*')).filter((node) => node.localName === 'wpt');
  if (waypoints.length === 0) throw new Error('No cache waypoints were found in this GPX file.');

  const seen = new Set();
  const caches = [];
  for (const waypoint of waypoints) {
    const latitude = Number(waypoint.getAttribute('lat'));
    const longitude = Number(waypoint.getAttribute('lon'));
    if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) continue;
    const cacheNode = Array.from(waypoint.getElementsByTagName('*')).find((node) => node.localName === 'cache');
    const code = childText(waypoint, 'name') || `GPX-${caches.length + 1}`;
    if (seen.has(code)) continue;
    seen.add(code);
    const cacheName = cacheNode ? childText(cacheNode, 'name') : '';
    const description = cacheNode
      ? plainText(childText(cacheNode, 'short_description') || childText(waypoint, 'desc'))
      : plainText(childText(waypoint, 'desc'));
    caches.push({
      externalCode: code,
      name: cacheName || description || code,
      latitude,
      longitude,
      type: normalizeType(cacheNode ? childText(cacheNode, 'type') : childText(waypoint, 'type')),
      difficulty: cacheNode ? Number(childText(cacheNode, 'difficulty')) || null : null,
      terrain: cacheNode ? Number(childText(cacheNode, 'terrain')) || null : null,
      size: cacheNode ? childText(cacheNode, 'container') || null : null,
      hint: cacheNode ? childText(cacheNode, 'encoded_hints') || null : null,
      description: description || null,
    });
  }
  if (caches.length === 0) throw new Error('The GPX contained no waypoints with usable coordinates.');
  return caches;
}

export function combineCacheLists(lists) {
  const cachesByCode = new Map();
  for (const caches of lists) {
    for (const cache of caches) cachesByCode.set(cache.externalCode, cache);
  }
  return Array.from(cachesByCode.values());
}

export const SAMPLE_CACHES = [
  { externalCode: 'DEMO-01', name: 'Granite Footbridge', latitude: 50.74092, longitude: 15.3097, type: 'traditional', difficulty: 1.5, terrain: 2, size: 'Small', hint: 'Look below the weathered edge.' },
  { externalCode: 'DEMO-02', name: 'Old Spruce Marker', latitude: 50.7453, longitude: 15.2971, type: 'traditional', difficulty: 2, terrain: 2.5, size: 'Micro', hint: 'The oldest tree points the way.' },
  { externalCode: 'DEMO-03', name: 'Ridge Survey Stone', latitude: 50.7348, longitude: 15.3154, type: 'multi', difficulty: 2.5, terrain: 3, size: 'Regular', hint: 'Begin at the carved benchmark.' },
];
